module.exports = __webpack_public_path__ + "color_palette_pink_summer_design_ida_awards.jpg?3e244c0c3c6d2086d096cb9b33187160";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/ida/color_palette_pink_summer_design_ida_awards.jpg
// module id = 61
// module chunks = 0